import react, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import Table from "../../../Layout/Table/Table";
import { Puff } from "react-loading-icons";
import {
  Input,
  TextArea,
  Select,
  SelectCountries,
  InputImage,
  Switch,
} from "../../../Layout/Forms/Form";
import BillingRequests from "../BillingRequests";
import NavBar from "../../../../components/NavBar";

const Account = () => {
  const navigate = useNavigate();
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    form: {
      id: 0,
      name_comercial: "",
      name_company: "",
      nipc: "",
      email: "",
      phone_country: "",
      phone_number: "",
      address: "",
      city: "",
      postal_code: "",
      country: "",
    },
    info: {
      listCountryContact: [],
      countryList: [],
    },
    errors: {},
  });

  const seriaizeCountryList = () => {
    if (
      data &&
      data.info.listCountryContact &&
      data.info.listCountryContact.length > 0
    )
      return data.info.listCountryContact.map((item) => {
        return {
          label: item.name,
          value: item.phone_country,
          icon: item.icon,
        };
      });
  };

  const requestAccountInfo = async () => {
    setIsLoading(true);
    document.title = "Account Info | Nightspot Dashboard";
    let info = await BillingRequests.getAccountInfo(params);
    if (info && info.status) {
      setData(info.data);
    }
    setIsLoading(false);
  };

  useEffect(async () => {
    requestAccountInfo();
  }, []);

  const handlerSaveAccount = async () => {
    setIsLoading(true);
    let request = await BillingRequests.saveAccountInfo(data.form);
    if (request && request.status) {
      navigate("/my/billing/invoices");
    } else {
      setData({
        ...data,
        errors: request.errors,
      });
    }
    setIsLoading(false);
  };

  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setData({
        ...data,
        form: {
          ...data.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };
  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-2 d-none d-sm-block">
            <Navigation />
          </div>
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-8">
                    <h2 className="dashboard-h2">Dados de faturação</h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-10">
                    <div className="row">
                      <div className="col-12 col-sm-8 ">
                        <Input
                          label="Nome empresa"
                          name="name_company"
                          value={data.form.name_company}
                          onChange={(e) => handleChangeInputs(e)}
                          errors={data.errors}
                        />
                      </div>
                      <div className="col-12 col-sm-4 ">
                        <Input
                          label="NIF"
                          name="nipc"
                          value={data.form.nipc}
                          onChange={(e) => handleChangeInputs(e)}
                          errors={data.errors}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-8 ">
                        <Input
                          label="Email Faturação"
                          name="email"
                          value={data.form.email}
                          onChange={(e) => handleChangeInputs(e)}
                          errors={data.errors}
                        />
                      </div>
                      <div className="col-12 col-sm-4 ">
                        <div className="row">
                          <div className="col-2 ">
                            <SelectCountries
                              label="&nbsp;"
                              name="phone_country"
                              value={data.form.phone_country}
                              onChange={(e) => handleChangeInputs(e)}
                              options={seriaizeCountryList()}
                              errors={data.errors}
                            />
                          </div>
                          <div className="col-10">
                            <Input
                              label="Nº Telemóvel"
                              name="phone_number"
                              value={data.form.phone_number}
                              onChange={(e) => handleChangeInputs(e)}
                              errors={data.errors}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <Input
                          label="Morada"
                          name="address"
                          value={data.form.address}
                          onChange={(e) => handleChangeInputs(e)}
                          errors={data.errors}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <Select
                          label="Pais"
                          name="country"
                          value={data.form.country}
                          onChangeOption={(e) => handleChangeInputs(e)}
                          options={data.info.countryList}
                          style={{ textAlign: "center" }}
                          errors={data.errors}
                        />
                      </div>
                      <div className="col-4">
                        <Input
                          label="Localidade"
                          name="city"
                          value={data.form.city}
                          onChange={(e) => handleChangeInputs(e)}
                          errors={data.errors}
                        />
                      </div>
                      <div className="col-4">
                        <Input
                          label="Código Postal"
                          name="postal_code"
                          value={data.form.postal_code}
                          onChange={(e) => handleChangeInputs(e)}
                          errors={data.errors}
                        />
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-12">
                        <button
                          className="btn btn-primary"
                          onClick={() => handlerSaveAccount()}
                        >
                          Guardar dados
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default Account;
